// Wellness score classification utility for Wellness page cards
export interface WellnessScoreDisplay {
  label: string;
  className: string;
}

export const classifyScore = (score: number): WellnessScoreDisplay => {
  if (score < 50) {
    return {
      label: 'Low',
      className: 'wellness__card-risk--high-risk'
    };
  } else if (score < 75) {
    return {
      label: 'Moderate',
      className: 'wellness__card-risk--moderate-risk'
    };
  } else {
    return {
      label: 'High',
      className: 'wellness__card-risk--low-risk'
    };
  }
};

export const formatScoreDisplay = (score: number): string => {
  return `${score}%`;
};

